<template>
  <div>
    <span>
      {{ passwordNeverExpires }}
    </span>
  </div>
</template>

<script>

export default {
  name: 'PasswordNeverExpiresText',

  props: {
    getPasswordExpiresText: {
      default: null,
      type: Function,
    },
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    passwordNeverExpires() {
      let passwordExpiresText = '';

      if (this.item && this.getPasswordExpiresText) {
        passwordExpiresText = this.getPasswordExpiresText(this.item);
      }

      return passwordExpiresText;
    },
  },
};
</script>
